import { render, staticRenderFns } from "./NetPaListPageCard.vue?vue&type=template&id=1bc905f4&"
import script from "./NetPaListPageCard.vue?vue&type=script&lang=js&"
export * from "./NetPaListPageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports